import mergeMessageStatus from './mergeMessageStatus';

// Type-level merge for Message: the entity still holds its previous fields, so `status` and `error`
// from the same payload are weighed against the stored status. Apollo runs it a second time once the
// entity is written, with a Reference as `incoming`, and there is nothing left to decide then.
const mergeMessage = (existing, incoming, options) => {
  if (!existing || !incoming || options.isReference(incoming) || !('status' in incoming)) {
    return options.mergeObjects(existing, incoming);
  }

  const status = mergeMessageStatus(options.readField('status', existing), incoming);
  // A stored entity that never selected `status` has no say over the incoming one.
  const resolved = status === undefined || status === incoming.status
    ? incoming
    : { ...incoming, status };
  return options.mergeObjects(existing, resolved);
};

export default mergeMessage;
